import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { UserConfigurationService } from '../userconfiguration/user-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementBannerService {
  private readonly configService = inject(UserConfigurationService);
  private static readonly CSS_VAR = '--announcement-banner-height';
  private readonly _heightPx = signal(0);
  public readonly heightPx = this._heightPx.asReadonly();
  public notification = signal<string | undefined>(undefined);
  public isFetched = signal<boolean>(false);
  public isAlreadyClosedNotificationBannerInStartPage = signal(false);

  private readonly _isDismissed = signal(false);

  public readonly isVisible = computed(() => !!this.notification() && !this._isDismissed());

  constructor() {
    this.notification.set(this.configService.getOrDefault('STARTPAGE_NOTIFICATION_TEMPLATE'));
    effect(() => {
      const value = this.heightPx();
      if (!document?.documentElement) return;
      document.documentElement.style.setProperty(AnnouncementBannerService.CSS_VAR, `${value}px`);
    });
  }

  setHeight(px: number): void {
    this._heightPx.set(px);
  }

  dismiss(): void {
    this._isDismissed.set(true);
  }
}
